import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Ban, Unlock } from "lucide-react";
import api from "../lib/api";

export default function SuspensionsCard() {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/suspensions").then(({ data }) => setList(data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  const unsuspend = async (id) => {
    try { await api.post(`/admin/users/${id}/unsuspend`); toast.success("Sospensione revocata"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  if (list === null) return null;
  return (
    <div className={`ga-card p-5 ${list.length ? "border-2 border-slate-900" : ""}`} data-testid="suspensions-card">
      <div className="text-xs font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5"><Ban className="w-3.5 h-3.5 text-slate-900" /> Account sospesi ({list.length})</div>
      <div className="mt-1 text-xs text-slate-500">Sospensione automatica di 7 giorni dopo più di 3 segnali anti-elusione. L'utente può consultare ma non ordinare, offrire o scrivere.</div>
      {list.length === 0 && <div className="mt-2 text-sm text-slate-500" data-testid="suspensions-empty">Nessun account sospeso.</div>}
      <div className="mt-3 space-y-2">
        {list.map(s => (
          <div key={s.id} className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-slate-200 p-3 text-sm" data-testid={`suspension-${s.id}`}>
            <div className="min-w-0">
              <span className="font-semibold text-slate-900">{s.name}</span> <span className="text-xs font-mono text-slate-500">({s.role === "supplier" ? "fornitore" : "acquirente"} · {s.email})</span>
              <div className="text-xs text-slate-600 mt-0.5">Fino al {new Date(s.suspended_until).toLocaleString("it-IT")} · sospensioni totali: {s.suspensions_count}</div>
            </div>
            <button onClick={() => unsuspend(s.id)} className="inline-flex items-center gap-1 rounded-full border border-slate-300 px-3 py-1 text-xs font-semibold hover:bg-slate-50" data-testid={`unsuspend-${s.id}`}><Unlock className="w-3 h-3" /> Revoca</button>
          </div>
        ))}
      </div>
    </div>
  );
}
